import React from 'react';
import PathfindingVisualizer from './PathfindingVisualizer/PathfindingVisualizer';
import './PathfindingVisualizerPage.css';

const PathfindingVisualizerPage = () => (
  <div className="pathfinding-visualizer">
    <PathfindingVisualizer />
  </div>
);

export default PathfindingVisualizerPage;
